import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-pricing';

export default function Example() {
  return (
    <>
      <Head>
        <title>A Guide to Effective eBay Pricing in 2022</title>
        <meta name='description' content='Learn how to attract more potential customers with effective eBay pricing!' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-pricing' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-pricing' />
        <meta property='og:title' content='A Guide to Effective eBay Pricing in 2022' />
        <meta
          property='og:description'
          content='Learn how to attract more potential customers with effective eBay pricing!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 14th, 2022' />
        <meta property='article:modified_time' content='April 14th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
